const ImageBox = ({ className, src, alt="", objectFit="cover" }) => {

  const fitStyle = {
    contain: "object-contain",
    cover: "object-cover",
  }[objectFit]

  return (
    <div className={className}>
      <img className={`w-full h-full ${fitStyle}`} src={src} alt={alt} />
    </div>
  )
}

export default ImageBox